import { useTranslation } from 'react-i18next';
import _get from 'lodash/get';
import SelectPanel from '@lib/components/SelectPanel/SelectPanel';
import { SectorOption, SiteOption } from '@lib/components/SelectPanel/options';
import { GetLoadOptions } from '@lib/components/Select/types';
import { getOptionsArrayValidation } from '@lib/utils/validationUtils';
import {
  FieldChangeCallBackArgs,
  FieldItem,
  Values,
} from '@lib/interfaces/form';
import generateIdsFieldKey from '@lib/utils/generateIdsFieldKey';
import formStyles from '@lib/assets/styles/Form.module.scss';
import { materialSymbolsOutlined } from '@lib/enums/common';
import { FieldNames } from '../enums';

export default function useFilterFields({
  getSitesLoadOptions,
  getSectorsLoadOptions,
}: {
  getSitesLoadOptions: GetLoadOptions;
  getSectorsLoadOptions: GetLoadOptions;
}): FieldItem[] {
  const { t } = useTranslation();
  return [
    {
      name: FieldNames.Sectors,
      label: t('sector'),
      element: SelectPanel,
      validation: getOptionsArrayValidation({ t }),
      formItemClassName: formStyles.formColumnAuto,
      hideErrorsSpace: true,
      componentProps: {
        defaultOptions: false,
        getLoadOptions: getSectorsLoadOptions,
        renderOption: SectorOption,
        isAsync: true,
        isMulti: true,
        showTabs: true,
        buttonProps: {
          leftIcon: 'share_location',
          leftIconClassName: materialSymbolsOutlined,
        },
      },
      fieldChangeCallBack: ({ setValue, name }: FieldChangeCallBackArgs) => {
        if (name === FieldNames.Sectors) {
          setValue(FieldNames.Sites, [], {
            shouldValidate: false,
          });
        }
      },
      isOptionalFn: () => false,
    },
    {
      name: FieldNames.Sites,
      label: t('site'),
      element: SelectPanel,
      validation: getOptionsArrayValidation({ t }),
      formItemClassName: formStyles.formColumnAuto,
      hideErrorsSpace: true,
      componentProps: {
        defaultOptions: false,
        getLoadOptions: getSitesLoadOptions,
        renderOption: SiteOption,
        isAsync: true,
        isMulti: true,
        showTabs: true,
        buttonProps: {
          leftIcon: 'home_pin',
          leftIconClassName: materialSymbolsOutlined,
        },
      },
      getFieldKeyFn: (values: Values) => {
        const rawSectorIds = _get(values, FieldNames.Sectors, []) as Array<
          { value?: string } | string
        >;
        return generateIdsFieldKey(rawSectorIds, {
          prefix: `${FieldNames.Sectors}-sites`,
          emptyKey: `${FieldNames.Sectors}-no-sites`,
        });
      },
      isOptionalFn: () => false,
    },
  ];
}

export { FieldNames } from '../enums';
